export default {
    bathroom: 'Baño',
    furniture: 'Mueble',
    kitchen: 'Cocina',
    qrcodeSummary: "Escanee el código QR con su smartphone para ver el producto en realidad aumentada",
    seeinar: 'Ver en RA',
    storage: 'Almacenaje',
}